import React, { Component } from "react";

import Slide from "../Dashboard/Slide";
import TTPModal from "../Common/Modal/TTPModal";

class DashboardSlidesModal extends Component {
  render() {
    const { dashboard } = this.props;

    return (
      <TTPModal
        title={dashboard && dashboard.label}
        visible={this.props.isVisible}
        loading={false}
        footer={null}
        handleCancel={this.props.handleCancelModal}
        width={1000}
      >
        {dashboard &&
          dashboard.slides.map((slide, i) => {
            return (
              <Slide
                key={i}
                slide={slide}
                isResponsive={true}
                handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
                comments={[]}
                dashboardPage={true}
                inSlideView={true}
              />
            );
          })}
      </TTPModal>
    );
  }
}

export default DashboardSlidesModal;



// WEBPACK FOOTER //
// ./src/components/DashboardList/DashboardSlidesModal.js